/* global acc */
import $ from 'jquery';
import {isEmpty,mediaPath,acc} from '../Helpers';
import {state} from '../State';
export default  class ToolbarBtn {

    constructor(settings = {id,className,label,type,icon,alt,show:true,cb}) {
        this._data ={};
        this.id = settings.id;
        this.label = settings.label;
        this.type = settings.type;
        this.icon = settings.icon ? mediaPath(settings.icon) : false;
        this.alt = settings.alt ? settings.alt : settings.label;
        this.className = settings.className;
        this.show =  settings.show;
        this.active =  false;
        this.cb =  settings.cb;

    }

    get elem(){ return this._data.elem}
    set elem(x){ this._data.elem = x }

    get id(){ return this._data.id}
    set id(x){ this._data.id = x }

    get show(){ return this._data.show}
    set show(x){ this._data.show = x }

    get className(){ return this._data.className}
    set className(x){ this._data.className = x }

    get alt(){ return this._data.alt}
    set alt(x){ this._data.alt = x }

    get icon(){ return this._data.icon}
    set icon(x){ this._data.icon = x }

    get cb(){ return this._data.cb}
    set cb(x){ this._data.cb = x }

    get type(){ return this._data.type}
    set type(x){
        this._data.type = x
    }

    get label(){ return this._data.label}
    set label(x){ this._data.label = x ;
        if(!isEmpty(this.elem)){
            this.elem.find('span').html(x)
        }
    }

    get active(){ return this._data.active}
    set active(x){
        this._data.active = x
        if(!isEmpty(this.elem)){
            this.elem.attr('aria-selected',(x ? 'true' : 'false'))
        }
    }


    render(){
        if(!this.show){return}
        this.elem = $(`<button id="${this.id}" class="${this.className}" data-type="${this.type}"  aria-selected="${this.active}" tabindex="0">`)
        const icon = this.icon ?  `<img src="${this.icon}" alt="${this.alt}">` : null;
        const label =$('<span>').text(this.label)
        this.elem.html([icon,label])
        if(typeof this.cb ==='function'){
            this.elem.click(this.cb)
        }

        return this.elem
    }


}